export const OFFSET_GAZZLIFT = {
    Y: 0.11,
};

export const OFFSET_GLIDERS = {
    Y: 0.015,
};
